import { PropsWithChildren } from 'react';
import dynamic from 'next/dynamic';

import { ChakraProvider, ToastProps } from '@chakra-ui/react';

import { v2Theme } from './v2';

const ToastBody = dynamic<ToastProps>(() => import('~/components/toast-body').then((mod) => mod.ToastBody));

export type UDS2ThemeProviderProps = PropsWithChildren<{}>;

export function UDS2ThemeProvider({ children }: UDS2ThemeProviderProps) {
  return (
    <ChakraProvider
      theme={v2Theme}
      toastOptions={{
        defaultOptions: {
          position: 'top',
          duration: 8000,
          isClosable: true,
          render: (props) => <ToastBody {...props} />,
        },
      }}
    >
      {children}
    </ChakraProvider>
  );
}
